import React from 'react'

function Footer() {
  return (
    <footer>
        <div className="footer-top footer-bg pt-60 pb-60 d-flex px-3 px-lg-5 px-md-4 justify-content-center align-items-center">
            <div className="w-100" style={{maxWidth: "1430px"}}>
                <div className="row justify-content-between" >
                    <div className="col-xl-5 col-lg-5  col-md-12 col-sm-12 col-12   " style={{maxWidth: "536px"}}>
                        <div className="">
                            <div className="footer-logo mb-35">
                                <a href=" #"><img src="assets/img/logo/f-logo.png" alt=""/></a>
                            </div>
                            <div className="footer-text">
                                <div className="fw-title">
                                    <h5>Don’t miss our latest News</h5>
                                </div>
                                <div className="footer-newsletter">
                                    <form action=" #">
                                        <input type="text" placeholder="Enter your email"/>
                                        <button>
                                            <span>subscibe</span>
                                            <div className="subscribe-btn">
                                                <a href=" #"><img src="assets/img/images/arrow-up-right.svg" alt=""/></a>
                                            </div>
                                        </button>
                                    </form>
                                </div>
                                <h1>KATANA INU is a project from <span className="heilight">CHAINVISION GAMES</span></h1>
                                <p>Nothing on this website constitutes financial advice, and it is always recommended to
                                    consult a qualified financial
                                    advisor before participating in any token or NFT purchases.</p>
                                <p>Buy Katana Inu NFTs only from katanainu.com or kainu.io subdomains to be safe. Check
                                    the website's address for on our
                                    main website www.katanainu.com and go to the "Minting NFTs" section to verify.</p>
                                <span>Ask in our telegram or discord channel for confirmation. Avoid other
                                    websites!</span>

                            </div>
                        </div>
                    </div>
                    <div className="col-xl-7 align-items-end col-lg-7   col-md-12 col-sm-12 col-12  row justify-content-between">

                    <div className="col-xl-4 col-lg-4 col-sm-6 col-6 col-md-4">
                        <div className="footer-content">
                            <h2>products</h2>
                            <ul>
                                <li>
                                    <div className="footer-product-links">
                                        <a href=" https://pancakeswap.finance/swap?outputCurrency=0x6D6bA21E4C4b29CA7Bfa1c344Ba1E35B8DaE7205"  target="_blank">pancakeswap</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li>
                                    <div className="footer-product-links">
                                        <a href="https://app.uniswap.org/#/swap?inputCurrency=0x2e85ae1C47602f7927bCabc2Ff99C40aA222aE15"  target="_blank">Uniswap</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li>
                                    <div className="footer-product-links">
                                        <a href="https://www.katanainu.com/assets/resources/katanainuwhitepaper.pdf"  target="_blank">Whitepaper</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li>
                                    <div className="footer-product-links">
                                        <a href=" #"  target="_blank">Roadmap</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li>
                                    <div className="footer-product-links">
                                        <a href="https://www.katanainu.com/assets/resources/katanainutokenomics.pdf"  target="_blank">Tokenomics</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li> 
                                    <div className="footer-product-links">
                                        <a href="https://www.katanainu.com/faq"  target="_blank">FAQ</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li>
                                    <div className="footer-product-links">
                                        <a href=" #"  target="_blank">Chainplay</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-4 col-lg-4 col-sm-6 col-6">
                        <div className="footer-content">
                            <div className="top-line">
                                <img src="assets/img/images/footer-links-top-line.svg" alt=""/>
                            </div>
                            <h2>need help?</h2>
                            <ul>
                                <li>
                                    <div className="footer-product-links">
                                        <a href=" #"  target="_blank">Contact us</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li>
                                    <div className="footer-product-links">
                                        <a href="https://discord.com/invite/katanainu"  target="_blank">Discord</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li>
                                    <div className="footer-product-links">
                                        <a href="https://medium.com/@katanainu/katana-inu-a-great-play2earn-battle-royale-pc-game-with-nft-marketplace-on-layer-2-a56f9bbcce79"  target="_blank">Medium</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li>
                                    <div className="footer-product-links">
                                        <a href="https://www.reddit.com/r/katanainu/" target="_blank">Reddit</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li>
                                    <div className="footer-product-links">
                                        <a href="https://www.katanainu.com/" target="_blank">Chainvision Games</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-4 col-lg-4 col-sm-6 col-6">
                        <div className="footer-content mt-50">
                            <div className="top-line">
                                <img src="assets/img/images/footer-links-top-line.svg" alt=""/>
                            </div>
                            <h2>follow us</h2>
                            <div className="footer-socials">
                                <a href="https://twitter.com/katanainu"  target="_blank">
                                    <img src="assets/img/images/footer-twitter.svg" alt=""/>
                                </a>
                                <a href="https://discord.com/invite/katanainu"  target="_blank">
                                    <img src="assets/img/images/footer-telegram.svg" alt=""/>
                                </a>
                                <a href="https://t.me/katanainu"  target="_blank">
                                    <img src="assets/img/images/footer-discord.svg" alt=""/>
                                </a>
                                <a href="https://www.instagram.com/katanainu/"  target="_blank">
                                    <img src="assets/img/images/footer-insta.svg" alt=""/>
                                </a>
                            </div>
                            <ul>
                                <li>
                                    <div className="footer-product-links">
                                        <a href="https://www.katanainu.com/termsofservicekatanainu.docx"  target="_blank">Terms of Service</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                                <li>
                                    <div className="footer-product-links">
                                        <a href="https://www.katanainu.com/cookiespolicy.pdf"  target="_blank">Cookies Policies</a>
                                    </div>
                                    <div className="footer-line"></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    </div>

                </div>
            </div>
        </div>
        <div className="copyright-wrap s-copyright-wrap flex px-3 px-lg-5 px-md-4">
            <div className="custom-container">
                <div className="row justify-content-center">
                    <div className="col-12 d-flex justify-content-center align-items-center">
                        <div className="copyright-text">
                            <p>Copyright © 2023 <a href=" #">Katana Inu</a> All Rights Reserved.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer